import { PropsOf } from 'types';
import connect from './connect';
import Notifications from './Notifications';

export default connect(Notifications);
export type NotificationsProps = PropsOf<ReturnType<typeof connect>>;
